import { format, isValid, parseISO, subDays, subMonths } from "date-fns";
import { enUS, fi, sv } from "date-fns/locale";
import type { Locale } from "@/i18n";

const DATE_FNS_LOCALES: Record<Locale, typeof enUS> = { en: enUS, sv, fi };

const ISO_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

export function todayISO(): string {
  return format(new Date(), "yyyy-MM-dd");
}

export function yesterdayISO(): string {
  return format(subDays(new Date(), 1), "yyyy-MM-dd");
}

export function monthsAgoISO(months: number, from: Date = new Date()): string {
  return format(subMonths(from, months), "yyyy-MM-dd");
}

export function isValidIsoDate(value: string | null | undefined): value is string {
  if (!value || !ISO_DATE_PATTERN.test(value)) return false;
  return isValid(parseISO(value));
}

/** Localized, human-readable rendering of a YYYY-MM-DD date, e.g. "3 Mar 2026". */
export function formatDateDisplay(isoDate: string, locale: Locale): string {
  return format(parseISO(isoDate), "d MMM yyyy", { locale: DATE_FNS_LOCALES[locale] });
}

/** Compact rendering used for chart axis ticks, e.g. "3 Mar". */
export function formatDateShort(isoDate: string, locale: Locale): string {
  return format(parseISO(isoDate), "d MMM", { locale: DATE_FNS_LOCALES[locale] });
}
